import {FC} from 'react';
import {Toggle} from '@rocket-ui/components';
import {formatSbpPhoneForReview} from '../../model/sbpPhone';
import type {SelectedBank} from '../../model/selectedBank';
import styles from '../AccountReviewStep/AccountReviewStep.module.css';

const PRIMARY_HINT =
	'Эти реквизиты будут использоваться в случае невозможности оплатить по основному способу';

type Props = {
	recipient: string;
	phone: string;
	bank: SelectedBank | null;
	isPrimary: boolean;
	showPrimaryToggle?: boolean;
	onPrimaryChange: (value: boolean) => void;
	error?: string | null;
};

export const SbpReviewStep: FC<Props> = ({
	recipient,
	phone,
	bank,
	isPrimary,
	showPrimaryToggle = true,
	onPrimaryChange,
	error,
}) => (
	<div className={styles.root}>
		<h2 className={styles.title}>Давайте сверим</h2>

		<dl className={styles.fields}>
			<div className={styles.field}>
				<dt className={styles.label}>Получатель</dt>
				<dd className={styles.value}>{recipient}</dd>
			</div>
			<div className={styles.field}>
				<dt className={styles.label}>Номер телефона</dt>
				<dd className={styles.value}>{formatSbpPhoneForReview(phone)}</dd>
			</div>
		</dl>

		{bank ? (
			<div className={styles.bankRow}>
				{bank.iconUrl ? (
					<img className={styles.bankIcon} src={bank.iconUrl} alt="" />
				) : (
					<span className={styles.bankIconFallback} aria-hidden />
				)}
				<span className={styles.bankName}>{bank.shortName ?? '—'}</span>
			</div>
		) : null}

		{showPrimaryToggle ? (
			<div className={styles.primaryBlock}>
				<div className={styles.primaryRow}>
					<p className={styles.primaryLabel}>Сделать основным способом для получения выплат</p>
					<Toggle value={isPrimary} onChange={onPrimaryChange} />
				</div>
				<p className={styles.primaryHint}>{PRIMARY_HINT}</p>
			</div>
		) : null}

		{error ? <p className={styles.error}>{error}</p> : null}
	</div>
);
